import { Route } from 'react-router-dom';
import ActionRoute from '../components/ActionRoute';
import ClientApprovalsLiveRoute from '../components/clientApprovals/portal/ClientApprovalsLiveRoute';
import ClientApprovalVersionPage from '../pages/ClientApprovalVersionPage';
import ClientApprovalUnavailablePage from '../pages/ClientApprovalUnavailablePage';

/**
 * #3187 APPROVE.4 — the Client Portal approval URLs, used by App.tsx's route
 * table and by the ActionRoute navigation-race test, so the test drives the
 * real wiring. Both are dark until CLIENT_APPROVAL_ENFORCEMENT_LIVE is true
 * (ClientApprovalsLiveRoute renders nothing until then, as main does for an
 * unmatched URL).
 *
 *   /client/approvals/unavailable                         G2's generic landing
 *   /client/approvals/:artefactId/requests/:requestId     the version view: a
 *       full login, or an APPROVE action session for that artefact (#3248)
 */
export const clientApprovalRoutes = (
  <>
    <Route
      path="/client/approvals/unavailable"
      element={<ClientApprovalsLiveRoute><ClientApprovalUnavailablePage /></ClientApprovalsLiveRoute>}
    />
    <Route
      path="/client/approvals/:artefactId/requests/:requestId"
      element={(
        <ClientApprovalsLiveRoute>
          <ActionRoute actionType="APPROVE" targetParam="artefactId">
            <ClientApprovalVersionPage />
          </ActionRoute>
        </ClientApprovalsLiveRoute>
      )}
    />
  </>
);
